import { render, staticRenderFns } from "./DoctorCommentCard.vue?vue&type=template&id=9e4d83e8&scoped=true"
import script from "./DoctorCommentCard.vue?vue&type=script&lang=js"
export * from "./DoctorCommentCard.vue?vue&type=script&lang=js"
import style0 from "./DoctorCommentCard.vue?vue&type=style&index=0&id=9e4d83e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4d83e8",
  null
  
)

export default component.exports